module.exports = __webpack_public_path__ + "img/Group 488.f81c45b5.png";